import { Store } from "@redotech/util/store";
import { useState } from "react";
import { useHandler } from "./hook";

/**
 * Store-backed state
 */
export function useStore<T>(
  store: Store<T>,
): [T, (value: T | ((prev: T) => T)) => void] {
  const [value, setValue] = useState(() => store.get());

  const setStore = useHandler((update: T | ((prev: T) => T)) => {
    const nextValue =
      typeof update === "function"
        ? // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
          (update as (prev: T) => T)(store.get())
        : update;

    setValue(nextValue);
    store.set(nextValue);
  });

  return [value, setStore];
}
